/** Llamadas HTTP del feature auditoría. */
import { apiRequest } from "../../lib/api";

export type ActorType = "staff" | "socio" | "superadmin" | "system";

export interface AuditLogEntry {
  id: number;
  empresa_id: number | null;
  request_id: string;
  actor_type: ActorType;
  actor_user_id: number | null;
  actor_socio_id: number | null;
  action: string;
  entity_type: string | null;
  entity_id: number | null;
  changes: Record<string, unknown> | null;
  meta: Record<string, unknown> | null;
  created_at: string;

  actor_user_nombre: string | null;
  actor_user_email: string | null;
}

export interface AuditLogPage {
  items: AuditLogEntry[];
  total: number;
  limit: number;
  offset: number;
}

export interface AuditFilters {
  action?: string | null;
  entity_type?: string | null;
  entity_id?: number | null;
  actor_user_id?: number | null;
  actor_type?: ActorType | null;
  desde?: string | null; // ISO datetime
  hasta?: string | null;
  q?: string | null;
  empresa_id?: number | null; // solo superadmin
  incluir_sistema?: boolean;
  limit?: number;
  offset?: number;
}

function toQuery(filters: AuditFilters): string {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v === null || v === undefined || v === "") continue;
    params.set(k, String(v));
  }
  return params.toString();
}

export function fetchAuditLog(filters: AuditFilters = {}): Promise<AuditLogPage> {
  const qs = toQuery(filters);
  return apiRequest<AuditLogPage>(
    `/api/v1/audit-log${qs ? `?${qs}` : ""}`,
  );
}

export function fetchAuditActions(): Promise<string[]> {
  return apiRequest<string[]>("/api/v1/audit-log/actions");
}
